import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-1c190b5e"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "assistantTools__container"
};
var _hoisted_2 = {
  "class": "assistantTools__title"
};
var _hoisted_3 = /*#__PURE__*/_createStaticVNode("<b data-v-1c190b5e>Having Issues?</b><p data-v-1c190b5e>Get 1:1 Help From The Developer Of This App Free of Charge</p><a href=\"https://discord.gg/PSDC7espu7\" data-v-1c190b5e><button class=\"button button--selected\" data-v-1c190b5e>Join The Discord</button></a><div style=\"margin-top:10px;\" data-v-1c190b5e>Or</div><a href=\"mailto:joey@aivitar.com\" data-v-1c190b5e><button class=\"button\" data-v-1c190b5e>Email Me</button></a>", 5);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", {
    style: {
      "margin-top": "50px"
    },
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return _ctx.$store.commit('updateShowAssistantTools', false);
    })
  }, "CLOSE")])]);
}